import { Field, Formik } from "formik"
import React, { useMemo } from "react"
import find from "lodash/find"
import Button from "../../../../components/Button"
import FieldDropdown from "../../../../components/fields/FieldDropdown"
import * as Yup from "yup"
import WpModal from "../../../../components/WpModal"
import { useTranslation } from "react-i18next"
import FieldTextarea from "../../../../components/fields/FieldTextarea"
import { convertErrorToForm } from "../../../../utils"
import FormNoFieldError from "../../../../components/FormNoFieldError"

export const INITIAL_TASK_VALUES = {
  title: "",
  target: "",
  position: "",
}

export default function AddTaskModalForm({
  isOpen,
  toggle,
  taskTreeOptions,
  onSubmit,
  taskProps = {},
  onClosed,
}) {
  const { t } = useTranslation(["translation", "field", "action"])

  const POSITION_OPTIONS = useMemo(() => {
    return [
      {
        label: "----",
        value: "",
      },
      {
        label: t("tasks.after"),
        value: "after",
      },
      {
        label: t("tasks.child_of"),
        value: "children",
      },
    ]
  }, [t])

  const AddTaskSchema = Yup.object({
    title: Yup.string().required(
      t("field:errors.mandatory", { field: t("field:task.title") })
    ),
  })

  return (
    <WpModal
      isOpen={isOpen}
      toggle={toggle}
      title={t("tasks.new_task_title")}
      onClosed={onClosed}
    >
      <Formik
        onSubmit={(values, actions) => {
          const { target, position, ...task } = values
          const taskPayload = {
            ...task,
            after: null,
            parent: null,
            resources: null,
            fixed_costs: null,
          }
          if (target && position) {
            if (position === "after") {
              taskPayload.after = target
              taskPayload.parent = find(taskTreeOptions, {
                value: target,
              }).parent
            } else if (position === "children") {
              taskPayload.parent = target
            }
          }
          return onSubmit(taskPayload, actions).catch(error => {
            actions.setErrors(convertErrorToForm(error))
          })
        }}
        validationSchema={AddTaskSchema}
        initialValues={{ ...INITIAL_TASK_VALUES, ...taskProps }}
      >
        {({ handleSubmit, isSubmitting, errors }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <p>{t("tasks.create_task_modal_message")}</p>
            <Field
              label={t("field:task.title")}
              name="title"
              className="mb-5"
              auto
              rows={2}
              component={FieldTextarea}
              required
            />
            <Field
              label={t("field:task.position")}
              name="position"
              placeholder="Select a postion"
              className="mb-5"
              component={FieldDropdown}
              capitalize={false}
              options={POSITION_OPTIONS}
            />
            <Field
              label={t("field:task.target")}
              name="target"
              placeholder="Select a target"
              component={FieldDropdown}
              capitalize={false}
              options={taskTreeOptions}
            />
            <div className="d-flex flex-row align-items-center justify-content-end pt-7">
              <Button size="lg" color="none" onClick={toggle}>
                {t("action:cancel")}
              </Button>
              <Button
                size="lg"
                disabled={isSubmitting}
                onClick={handleSubmit}
                className="ml-5"
              >
                {t("action:save")}
              </Button>
            </div>
            {errors.parent && (
              <div className='alert alert-danger mt-4'>
                {errors.parent}
              </div>
            )}
            <FormNoFieldError className='mt-4' />
          </form>
        )}
      </Formik>
    </WpModal>
  )
}
